/** @module Export/ExportTable/Widget */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/def",
	"csi/heading/_base",
	"csi/heading/Attribute",
	"csi/heading/Container",
	"csi/html",
	"csi/reflection",
	"csi/table/Widget",
	"csi/types",
	"csi/xml",
	"Export",
	"./Preferences"
], function(declare, _, def, csiHeading, Attribute, Container, html, reflection, Widget, types, xml, Export, Preferences) {

	var _validFormats = {};
	_validFormats[types.FORMAT_IMAGE] = 1;		// for ref/url
	_validFormats[types.FORMAT_RICH] = 1;		// for string
	_validFormats[types.FORMAT_TEXTAREA] = 1;	// for string

	var _validTypes = {};
	_validTypes[xml.ATTR_BOOLEAN] = 1;
	_validTypes[xml.ATTR_ERROR] = 1;
	_validTypes[xml.ATTR_REF] = 1;
	_validTypes[xml.ATTR_TIME] = 1;

	var _RawValueRenderer = declare(Attribute, {
		/**
		 * @override
		 * The query spec should be the same as when using the normal renderer so that filtering works as expected
		 */
		getQuerySpec: function(ctx, h, spec) {
			var temp = h.classRenderer;
			h.classRenderer = null;
			var ren = csiHeading.getHeadingRenderer(ctx, h);
			h.classRenderer = temp;

			console.assert(!!ren, "Export view does not support heading with key: " + h.getKey());

			return ren && ren.getQuerySpec(ctx, h, spec);
		},

		/**
		 * Handle properties and url attributes appropriately
		 */
		_getValue: function(ctx, h) {
			var node = ctx.getNode();
			var value;

			if (h.m_prop) {
				value = xml.nodeGetProperty(node, h.m_prop);
			} else {
				var type = xml.nodeAttributeGetType(node, h.m_id);

				if (ctx.hasContainerKey() && (type == xml.ATTR_URLMAP)) {
					value = ctx.keyValue;
				} else if (type == xml.ATTR_URL) {
					value = node[xml.idGetFile(h.m_id)];
				} else {
					value = this.inherited(arguments);

					if (type == xml.ATTR_ENUM) {
						value = xml.enumGetText(value);
					}
				}
			}

			return (value == null) ? value : String(value);
		}
	});

	var _RawValueContainerRenderer = declare(Container, {
		/**
		 * Set base renderer to the raw value renderer
		 */
		constructor: function() {
			this.renBase = csiHeading.getClassRenderer(_RawValueRenderer, xml.ATTR_STRING);
		}
	});

	return declare(Widget, {
		allowAutomaticHeight: false,
		_actionControllers: {
			CustomViewSaveAs: "Export/ExportTable/ExportCustomViewController",
			CustomViewManage: "Export/ExportTable/ExportCustomViewController",
		},

		prefClass: Preferences,

		// Boolean: indicate we only want to work with shared custom views
		prefSiteOnly: true,

		// String: Default value for the ImageExportFormat drop down
		imageExportFormat: "",

		/**
		 * @override
		 */
		canGroup: function() {
			return false;
		},

		/**
		 * @override
		 */
		canReport: function() {
			return false;
		},

		isSuspended: function() {
			// summary: override normal behavior when suspended is only in effect if set to suspended and suspend is an option
			return this.suspended;
		},

		/**
		 * Add native export setting to context so attributes will render correctly
		 */
		onContext: function(ctx) {
			ctx.bNativeExport = true;
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Change custom view options for export views
		 */
		onCustomViewAttributeOptions(options) {
			options.allowHidden = true;
			options.maxNumberOfAttributes = 255;
			options.noGroupSupport = true;
			options.noMatrixSupport = true;
			options.omitReferencedImages = true;
			this.inherited(arguments);
		},

		onViewPreferences: function() {
			// summary: ensure that suspended is always true when switching custom views for export
			this.inherited(arguments);
			this.set("suspended", true);
		},

		onViewToolbar: function(/*Toolbar*/tb) {
			// summary: remove plugins not desired for export
			tb.removePlugins(["charts", "pdf", "print", "Export"]);

			// even though there is a Suspend toolbar plugin, we do not allow suspended as an option in custom views (instead force to true)
			this.set("suspendIsOption", false);
		},

		postMixInProperties: function() {
			// summary: find view for given export definition
			var node = this.getViewNode();
			if (node) {
				var foundView = def.getClassViewDef(reflection.getClass(node.ClassName), Export.VIEW);
				if (foundView) {
					this.defView = foundView;
					this.urlDefaultView = node.View;
				}
			}

			// only allow matrices defined explicitly in the view
			this.defView.useMatrixCard = false;

			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: destroy chart node as it should not be available in export views
			html.destroyElement(this.chartNode);
			this.chartNode = null;
			this.inherited(arguments);
		},

		/**
		 * Override renderer class for all headings in view
		 */
		_resolveColumns() {
			this.inherited(arguments);

			this.columnData.traverse(true, function(c, sc) {
				var spec = sc || c;
				var h = spec.heading;
				var type = spec.type;
				var format = spec.format;
				var baseType = xml.attributeTypeGetBase(type) || type;

				if (h && !_validTypes[baseType] && !_validFormats[format]) {
					h.classRenderer = xml.attributeTypeIsContainer(type) ? _RawValueContainerRenderer : _RawValueRenderer;
				}
			});
		},

		/**
		 * @override
		 * Ignore current user in selection when attribute is an User Ref
		 */
		onCustomViewDataManagementOptions(options) {
			this.inherited(arguments);
			options.restrictFilterByCurrentUser = true;
		}
	});
});
